/**
 * API Client — re-exports the full `api` object with the same shape as before.
 *
 * All existing imports like:
 *   import { api, Notice, User, TeamMember } from "../services/api";
 *   import { uploadSchoolLogo, uploadOrgBanner } from "../services/api";
 * continue to work unchanged.
 */

// Domain modules
import { authApi } from "./auth";
import { noticesApi, setApiRef as setNoticesApiRef } from "./notices";
import { usersApi } from "./users";
import { circlesApi } from "./circles";
import { dashboardApi, setApiRef as setDashboardApiRef } from "./dashboard";
import { teamApi } from "./team";
import { templatesApi } from "./templates";
import { advertisementsApi } from "./advertisements";
import { termsApi } from "./terms";
import { emailPreferencesApi } from "./emailPreferences";
import { familyApi } from "./family";
import { dashboardAnnouncementsApi } from "./dashboardAnnouncements";
import { askNoticeboardApi } from "./askNoticeboard";
import { opsApi } from "./ops";
import { certificatesApi } from "./certificates";
import { signaturesApi } from "./signatures";
import { courseProgressApi } from "./courseProgress";
import { plannersApi } from "./planners";
import { novaApi } from "./nova";

// Assemble the unified api object
export const api = {
  auth: authApi,
  notices: noticesApi,
  users: usersApi,
  school: {
    // Removed old uploadLogo method - use uploadSchoolLogo function instead
  },
  circles: circlesApi,
  dashboard: dashboardApi,
  team: teamApi,
  templates: templatesApi,
  advertisements: advertisementsApi,
  terms: termsApi,
  emailPreferences: emailPreferencesApi,
  family: familyApi,
  dashboardAnnouncements: dashboardAnnouncementsApi,
  askNoticeboard: askNoticeboardApi,
  ops: opsApi,
  certificates: certificatesApi,
  signatures: signaturesApi,
  courseProgress: courseProgressApi,
  planners: plannersApi,
  nova: novaApi,
};

// Wire up forward references for modules that need the full api object
setNoticesApiRef(api);
setDashboardApiRef(api);

// Re-export standalone functions (from dashboard directly so bundlers always see named exports)
export { uploadSchoolLogo, uploadOrgBanner } from "./dashboard";

export type { ApiAward, ApiCertificate, ApiCertificateTemplate } from "./certificates";
export type { ApiSignature } from "./signatures";

// Re-export all types
export type {
  Notice,
  User,
  TeamMember,
  DashboardStats,
  School,
  ShareCodeResponse,
  NoticeRead,
} from "./types";
